export default __webpack_public_path__ + "static/media/3B069A_0_0.18d525c1.ttf";